import { z } from "zod";

export const isValidEmail = (email: string) => {
  const schema = z.object({
    email: z.string().email(),
  });

  return schema.safeParse({ email }).success;
};

export const titleCase = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
}
